module.exports = __webpack_public_path__ + "img/4_22.defd5d54.png";